/**
 * baseDualWrite.js — Phase 6 cutover: single live member writes under `_bases`.
 */

import { deleteDoc, doc, setDoc, updateDoc } from 'firebase/firestore';
import { collections, db } from 'firebaseConfig';

function cleanKey(value) {
  return typeof value === 'string' ? value.trim() : '';
}

function liveMemberRef(baseKey, memberKey) {
  return doc(db, collections.bases, cleanKey(baseKey), 'members', cleanKey(memberKey));
}

/**
 * @param {string} baseKey
 * @param {string} memberKey
 * @param {object} data
 * @param {{ merge?: boolean }} [options]
 */
export async function dualSetBaseMemberClient(baseKey, memberKey, data, options = {}) {
  const key = cleanKey(baseKey);
  const member = cleanKey(memberKey);
  if (!key || !member || !data || typeof data !== 'object') return;

  const merge = options.merge !== false;
  await setDoc(liveMemberRef(key, member), data, { merge });
}

/**
 * @param {string} baseKey
 * @param {string} memberKey
 */
export async function dualDeleteBaseMemberClient(baseKey, memberKey) {
  const key = cleanKey(baseKey);
  const member = cleanKey(memberKey);
  if (!key || !member) return;
  await deleteDoc(liveMemberRef(key, member));
}

/**
 * @param {string} baseKey
 * @param {string} memberKey
 * @param {object} patch
 */
export async function dualUpdateBaseMemberClient(baseKey, memberKey, patch) {
  const key = cleanKey(baseKey);
  const member = cleanKey(memberKey);
  if (!key || !member || !patch || typeof patch !== 'object') return;
  await updateDoc(liveMemberRef(key, member), patch);
}
